import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import request from '../../request';

const getSeason = () => {
  let month = new Date().getMonth() + 1;
  switch (true) {
    case month > 2 && month < 6:
      return 'spring';
    case month > 5 && month < 8:
      return 'summer';
    case month > 7 && month < 10:
      return 'default';
    case month > 9 && month <= 12:
      return 'winter';
    default:
      return 'fall';
  }
};

export default class Header extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  render() {
    let admin = localStorage.getItem('type') === 'admin';

    return (
      <header
        style={{
          backgroundImage: `url(/img/layout/header/${getSeason()}.jpg)`,
        }}
      >
        <div className="box">
          <div id="identity">
            <h1>
              <Link
                style={{
                  backgroundImage: `url(/img/layout/logo/${getSeason()}.png)`,
                }}
                to="/"
              >
                <span>Registered Sleepers</span>
              </Link>
            </h1>
          </div>
          <nav>
            {localStorage.getItem('token')
              ? <ul>
                  <li><Link to="/">Dashboard</Link></li>
                  <li><Link to="/types/scored">Archives</Link></li>
                  <li><Link to="/settings">Settings</Link></li>
                  {admin && <li><Link to="/bans">Bans</Link></li>}
                  <li>
                    <a
                      onClick={async e => {
                        e.preventDefault();
                        await request({
                          url: 'auth/logout',
                          method: 'POST',
                        });
                        localStorage.clear();
                        this.context.router.history.push('/auth/login');
                      }}
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              : <ul>
                  <li>
                    <a href="https://www.scoringsleepstudy.com/contact/">
                      Contact
                    </a>
                  </li>
                </ul>}
          </nav>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/global/header.js